export function formatClock(raw) {
    const digits = String(raw ?? '').replace(/\D/g, '').slice(0, 4)
    return digits.length < 2 ? digits : `${digits.slice(0, 2)}:${digits.slice(2)}`
}

export function clockToMinutes(text, period) {
    const digits = String(text ?? '').replace(/\D/g, '')
    if (digits.length !== 4) return null
    const hours = Number(digits.slice(0, 2))
    const minutes = Number(digits.slice(2))
    if (hours < 1 || hours > 12 || minutes > 59) return null
    return (hours % 12 + (period === 'PM' ? 12 : 0)) * 60 + minutes
}

export function minutesToClock(minutes) {
    if (minutes == null || minutes < 0) return { text: '', period: 'AM' }
    const hours = Math.floor(minutes / 60)
    return {
        text: `${String(hours % 12 || 12).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`,
        period: hours >= 12 ? 'PM' : 'AM',
    }
}

// Accept a completed 24-hour entry while keeping the field in the app's
// 12-hour format. Partial typing never changes the selected AM/PM segment.
export function normalizeClockInput(raw, period, previousText = '') {
    if (previousText.length === 3 && previousText.endsWith(':') && raw === previousText.slice(0, -1)) {
        return { text: previousText.slice(0, 1), period }
    }
    let digits = String(raw ?? '').replace(/\D/g, '').slice(0, 4)
    // 3–9 cannot begin a two-digit hour; move straight to minutes.
    if (digits.length < 4 && /^[3-9]/.test(digits)) digits = `0${digits}`.slice(0, 4)
    const text = digits.length === 2 && (String(raw).endsWith(':') || /^[3-9]/.test(String(raw)))
        ? `${digits}:`
        : formatClock(digits)
    // Refuse an impossible edit or paste; retain the last accepted entry.
    if ((digits.length >= 2 && Number(digits.slice(0, 2)) > 23)
        || (digits.length >= 3 && Number(digits[2]) > 5)) {
        return { text: previousText, period }
    }
    if (digits.length !== 4) return { text, period }
    const hours = Number(digits.slice(0, 2))
    const minutes = Number(digits.slice(2))
    if (hours > 23 || minutes > 59) return { text, period }
    if (hours === 0 || hours > 12) return minutesToClock(hours * 60 + minutes)
    return { text, period }
}

export function isInvalidClock(text, period) {
    const digits = String(text ?? '').replace(/\D/g, '')
    return (digits.length >= 2 && Number(digits.slice(0, 2)) > 23)
        || (digits.length === 4 && clockToMinutes(text, period) == null)
}
